import { css } from 'aphrodite'
import PropTypes from 'prop-types'
import { User } from 'react-feather'
import { COLOR_GRAY__500, COLOR_PRIMARY } from '../../lib/colors'

const IconUser = ({
  color = COLOR_GRAY__500,
  isActive = false,
  dynamicStyle,
}) => {
  return (
    <User
      color={isActive ? COLOR_PRIMARY : color}
      className={css(dynamicStyle)}
    />
  )
}

IconUser.propTypes = {
  color: PropTypes.string,
  isActive: PropTypes.bool,
  dynamicStyle: PropTypes.object,
}

export default IconUser
